export default (state = {}, action) => {
  switch (action.type) {
    case 'SETDADOS':
      return { ...state, ...action.dados };
    default:
      return state;
  }
};